<template>
  <v-dialog scrollable persistent v-model="dialogShow" max-width="900px">
    <template v-slot:activator="{ on }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            v-show="addButton"
            v-on="on"
            dark
            small
            fab
            color="primary"
            @click="openForm()"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </template>
        <span>Adicionar documento</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-system-bar color="primary" dark>
        <v-spacer></v-spacer>
        <v-icon color="#fff" @click="resetDialog">close</v-icon>
      </v-system-bar>
      <v-card-title class="mb-0 pb-0">
        <span class="title grey--text text--darken-2">{{setTitleForm(formData.id)}}</span>
      </v-card-title>
      <v-card-text class="mt-0 pt-0" style="min-height:400px;">
        <v-tabs
          id="documentsTab"
          class="pt-3"
          v-model="active"
          color="white"
          slider-color="primary"
        >
          <v-tab>Documento</v-tab>
          <v-tab>Responsáveis</v-tab>
          <v-tab :disabled="!formData.id">Anexos do documento</v-tab>
          <v-tab v-if="!validateLogTab">Logs</v-tab>

          <v-tab-item>
            <v-form ref="documentationForm" v-model="validForm" lazy-validation class="mt-0 pt-0">
              <v-container grid-list-md pa-0>
                <v-layout wrap px-0>
                  <v-flex sm6 px-3 pt-3>
                    <v-autocomplete
                      :disabled="viewForm"
                      :rules="$store.state.formRules.requiredSelect"
                      v-model="formData.condominium_id"
                      :items="condominiums"
                      item-text="name_fantasy"
                      item-value="condominium_id"
                      label="Selecione o condomínio"
                    ></v-autocomplete>
                  </v-flex>
                  <!-- <v-flex sm6 pt-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.description"
                      label="Descrição do documento"
                      :rules="$store.state.formRules.required"
                      required
                    ></v-text-field>
                  </v-flex>-->

                  <v-flex sm6 pl-3 pt-3>
                    <v-autocomplete
                      :disabled="viewForm"
                      v-model="formData.type"
                      :rules="$store.state.formRules.requiredSelect"
                      :items="$store.state.documents.docTypesList"
                      item-text="type"
                      item-value="id"
                      label="Selecione um grupo de documentos"
                      @change="getDocSubTypesLocal"
                    ></v-autocomplete>
                  </v-flex>

                  <!-- <v-flex sm1 pt-4>
                    <EditionDocTypes
                      class="justify-left"
                      :docTypes="$store.state.documents.docTypesList"
                      :reloadDocTypes="getDocTypes"
                    />
                  </v-flex>-->
                  <v-flex sm6 px-3>
                    <v-menu
                      v-model="sendDate"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          :disabled="viewForm"
                          clearable
                          return-masked-value
                          mask="##/##/####"
                          v-model="send_date_formated"
                          :rules="$store.state.formRules.birthDateRules"
                          label="Data de envio do documento"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        no-title
                        v-model="formData.send_date"
                        @input="sendDate = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex sm6 pl-3>
                    <v-autocomplete
                      :disabled="viewForm"
                      v-model="formData.subType"
                      :rules="$store.state.formRules.requiredSelect"
                      :items="$store.state.documents.docSubTypesList"
                      item-text="sub_type"
                      item-value="id"
                      label="Selecione um documento"
                    ></v-autocomplete>
                  </v-flex>

                  <template v-if="!formData.indefinite_period && !formData.obtaining">
                    <v-flex sm6 px-3>
                      <v-menu
                        v-model="valDate"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            clearable
                            :disabled="viewForm"
                            v-model="validate_date_formated"
                            :rules="$store.state.formRules.birthDateRules"
                            mask="##/##/####"
                            return-masked-value
                            label="Data do vencimento"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          no-title
                          v-model="formData.validate_date"
                          @input="valDate = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex sm6 px-3>
                      <v-text-field
                        :disabled="viewForm"
                        min="0"
                        type="number"
                        v-model="formData.alert_date"
                        suffix="dia(s) antes do vencimento."
                        label="Avisar sobre vencimento"
                        required
                      ></v-text-field>
                    </v-flex>
                  </template>

                  <v-flex sm6 px-3>
                    <v-checkbox
                      :disabled="viewForm"
                      class="mt-0"
                      v-model="formData.flag_not_send"
                      label="Documento não recebido pelo administrador"
                    ></v-checkbox>
                    <v-checkbox
                      :disabled="viewForm"
                      v-if="!formData.indefinite_period"
                      class="mt-0"
                      v-model="formData.obtaining"
                      label="Documento em obtenção"
                    ></v-checkbox>
                    <v-checkbox
                      :disabled="viewForm"
                      class="mt-0"
                      v-if="!formData.obtaining"
                      v-model="formData.indefinite_period"
                      label="Documento com prazo indeterminado"
                    ></v-checkbox>
                    <!-- <v-select
                      :rules="$store.state.formRules.requiredSelect"
                      v-model="formData.status"
                      :items="statusList"
                      item-text="text"
                      item-value="id"
                      label="Selecione o status do documento"
                    ></v-select>-->
                  </v-flex>
                  <!-- <v-flex sm6 px-3>
                <v-text-field
                  :disabled="viewForm"
                  min="1"
                  type="number"
                  v-model="formData.early_warning"
                  suffix="dia(s)."
                  label="Vencimento em"
                  :rules="$store.state.formRules.required"
                  required
                ></v-text-field>
                  </v-flex>-->

                  <v-flex xs6 px-3>
                    <v-textarea
                      :disabled="viewForm"
                      solo
                      name="input-7-4"
                      label="Observações"
                      v-model="formData.observation"
                    ></v-textarea>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-tab-item>
          <v-tab-item>
            <Responsible
              :disableFields="viewForm"
              :dialog="dialog"
              urlDel="/api/NotifyDocument/"
              :clearDataEdit="clearDataEdit"
              @updateResponsibleList="updateNotify"
              :dataEdit="formData.notify_document"
            />
          </v-tab-item>
          <v-tab-item>
            <UploadFilesDocs
              v-if="!viewForm"
              margin="none"
              :dialog="uploadDialog"
              uploadType="attchment"
              :openForm="() => openDialogForm('upLoad')"
              :closeForm="() => closeDialogForm('upLoad')"
              :sendFile="(data) => sendFile(data)"
              :idToEdit="idToEdit"
            />
            <importedDocsList
              :disableFields="viewForm"
              :confirmDelFileDocs="confirmDelFileDocs"
              :importedDocList="importedDocList"
              :editItem="(id) => openDialogForm('upLoad', id)"
            />
          </v-tab-item>
          <v-tab-item>
            <SystemLogs :tableData="tableLogs" />
          </v-tab-item>
        </v-tabs>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blueGrey darken-1" flat @click="resetDialog">Cancelar</v-btn>
        <v-btn v-if="!viewForm" color="primary" flat @click="doSave">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import * as moment from 'moment'
import UploadFilesDocs from '../../common/UploadFile'
import importedDocsList from './importedDocsList'
import Responsible from '../../common/Responsible'
import SystemLogs from '@/components/SystemLogs.vue'
import axios from 'axios'
import { logsDocumentation } from '@/services/documentation'

const defaultForm = {
  flag_not_send: false,
  subType: '',
  type: '',
  description: '',
  validate_date: new Date().toISOString().substr(0, 10),
  /* Avisar sobre vencimento */ alert_date: 0,
  status: '',
  observation: '',
  name_fantasy: '',
  /* prazo de aviso will_validate_date: 1, */
  condominium_id: '',
  received: false,
  obtaining: false,
  indefinite_period: false,
  send_date: new Date().toISOString().substr(0, 10)
}

export default {
  name: 'documentationsForm',

  components: {
    UploadFilesDocs,
    importedDocsList,
    Responsible,
    SystemLogs
  },

  props: {
    addButton: Boolean,
    openForm: Function,
    closeForm: Function,
    saveDocumentation: Function,
    dialog: Boolean,
    editFormData: Object
  },

  data () {
    return {
      notify: [],
      idUploaded: null,
      importedDocList: [],
      statusList: [
        { id: 1, text: 'Vigente' },
        { id: 2, text: 'A vencer' },
        { id: 3, text: 'Vencidos' },
        { id: 4, text: 'Não recebido pelo administrador' }
      ],
      active: 1,
      uploadDialog: false,
      condominiums: [],
      sendDate: false,
      valDate: false,
      // willValDate: false,
      docTypes: [],
      viewForm: false,
      permissionsList: [],
      formData: { ...defaultForm },
      idToEdit: null,
      validForm: true,
      tableLogs: []
    }
  },

  computed: {
    // send_date_formated() {
    //   return moment(this.formData.send_date).format("DD/MM/YYYY");
    // },
    // will_validate_date_formated() {
    //   return moment(this.formData.will_validate_date).format("DD/MM/YYYY")
    // },
    send_date_formated: {
      get () {
        return this.formData.send_date
          ? moment(this.formData.send_date).format('DD/MM/YYYY')
          : ''
      },
      set (value) {
        if (value) {
          if (value.length < 10) return
          let arrs = value.split('/')
          let date = `${arrs[2]}-${arrs[1]}-${arrs[0]}`
          if (!moment(date).isValid()) {
            this.formData.send_date = new Date().toISOString().substr(0, 10)
            return
          }
          this.formData.send_date = date
        } else {
          this.formData.send_date = ''
        }
      }
    },

    validate_date_formated: {
      get () {
        return this.formData.validate_date
          ? moment(this.formData.validate_date).format('DD/MM/YYYY')
          : ''
      },
      set (value) {
        if (value) {
          if (value.length < 10) return
          let arrs = value.split('/')
          let date = `${arrs[2]}-${arrs[1]}-${arrs[0]}`
          if (!moment(date).isValid()) {
            this.formData.validate_date = new Date()
              .toISOString()
              .substr(0, 10)
            return
          }
          this.formData.validate_date = date
        } else {
          this.formData.validate_date = ''
        }
      }
    },

    validateLogTab () {
      if (!this.viewForm) {
        return true
      }

      if (this.$store.state.permissions.permissions.documentation && !this.$store.state.permissions.permissions.documentation.edit) {
        return true
      }

      return false
    },

    dialogShow () {
      return this.dialog
    }
  },

  watch: {
    dialogShow (val) {
      if (val) {
        const tabs = document.querySelectorAll('#documentsTab .v-tabs__item')
        tabs[1].click()
        tabs[0].click()
        this.condominiums = this.$store.state.condominiums.condominiumList
        /* this.$parent.$parent.$refs.searchDocs.condominiums */
        if (this.$props.editFormData) {
          if (this.$props.editFormData.view) {
            this.viewForm = true

            this.getLogs()
          } else {
            this.viewForm = false
          }
          // console.log(this.$props.editFormData.id)
          if (this.$props.editFormData.id) {
            this.getImportedDocs(this.$props.editFormData.id)
          } else {
            this.importedDocList = []
          }
          this.formData = {
            ...this.editFormData
          }
          // console.log("------**", this.formData);
          // this.notify = this.formData.notify_document;
          this.formData.subType = this.editFormData.subType_id
          if (this.formData.type) {
            this.getDocSubTypesLocal()
          }
          // setTimeout(() => {
          //   console.log('settime')
          //   this.formData.subType = this.formData.subType_id;
          // }, 1000);
        }
      } else {
        this.notify = []
        this.importedDocList = []
        this.viewForm = false
        this.$refs.documentationForm.resetValidation()
        this.formData = { ...defaultForm }
        this.getDocSubTypesLocal()
      }
    }
  },

  mounted () {
    this.getPermissions()
    this.getDocTypes()
  },

  methods: {
    setTitleForm (id) {
      let returnTitle
      if (id) {
        returnTitle = 'Editar documento'
      } else {
        returnTitle = 'Novo documento'
      }
      if (this.viewForm) {
        returnTitle = 'Visualização'
      }
      return returnTitle
    },

    async getLogs () {
      const response = await logsDocumentation(this.editFormData.id)

      this.tableLogs = response
    },

    clearDataEdit (id) {
      let index = this.formData.notify_document.findIndex(
        (doc) => doc.id === id
      )
      this.formData.notify_document.splice(index, 1)
    },

    updateNotify (data) {
      // console.log("remove", index);
      if (data.remove) {
        let index = this.notify.findIndex(
          (user) => {
            return user.user_id === data.user_id && user.level === data.level
          }
          // user => user.id === data.id
        )

        this.notify.splice(index, 1)
        // console.log(this.notify);
        return
      }
      this.notify.push(data)
      // console.log(this.notify);
    },

    chunkString (str, length) {
      let splitStr = str.match(new RegExp('.{1,' + length + '}', 'g'))
      if (splitStr.length > 1) {
        return `${splitStr[0]}...`
      }
      return splitStr[0]
    },

    confirmDelFileDocs (data) {
      // console.log('delfilecontract', data)
      let obj = {
        message: `Você deseja excluir o arquivo "${this.chunkString(
          data.fileName,
          28
        )}"?`,
        title: 'Excluir arquivo',
        callback: (_) => {
          this.delFileDocs(data)
        },
        type: 'warning',
        btConfirm: { name: 'Sim', show: true },
        btCancel: { name: 'Não', show: true }
      }
      this.$store.commit('confirmMessage/showConfirmMessage', obj)
    },

    delFileDocs (data) {
      let obj = {
        // {id}
        url: '/api/document/attachment/delete/' + data.id,
        query: '',
        method: 'post'
      }
      this.$store.dispatch('request/doRequest', obj).then((response) => {
        if (!response) {
          return
        }
        let opts = {
          message: `Arquivo removido com sucesso`,
          type: 'success'
        }
        this.$store.commit('showAlert', opts)
        let index = this.importedDocList.findIndex(
          (fileContrat) => fileContrat.id === data.id
        )
        this.importedDocList.splice(index, 1)
        // this.initialize(this.lastSearch);
      })
    },

    getImportedDocs (id) {
      let obj = {
        url: '/api/document/ListAttachmentDoc/' + id,
        query: '',
        method: 'get',
        noLoader: true
      }
      this.$store.dispatch('request/doRequest', obj).then((response) => {
        this.importedDocList = response.data
      })
      // api/contract/ListAttchmentContract/{id}
      // this.importedContracsList = importedContracts
    },

    sendFile (data) {
      // api/document/uploadfiles
      let USER_TOKEN = localStorage.getItem('token')
      let AuthStr = 'Bearer '.concat(USER_TOKEN)
      let url = data.id
        ? `api/document/UpdateAttachmentDoc/${data.id}`
        : `/api/document/AttachmentDoc/${this.formData.id}`
      let formData = new FormData()

      for (var key in data) {
        formData.append(key, data[key])
      }
      this.$store.commit('showLoader', {
        circle: true
      })
      axios.defaults.baseURL =
        process.env.NODE_ENV === 'production'
          ? process.env.VUE_APP_API_URL
          : process.env.VUE_APP_API_URL_DEV
      axios
        .post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: AuthStr
          }
        })
        .then((resp) => {
          this.$store.commit('hideLoader')
          let obj = {
            message: 'Upload realizado com sucesso!',
            title: 'Sucesso',
            callback: (_) => {
              this.uploadDialog = false
              this.getImportedDocs(this.formData.id)
            },
            type: 'success',
            btConfirm: { name: 'Fechar', show: true },
            btCancel: { name: 'Fechar', show: false }
          }
          this.$store.commit('confirmMessage/showConfirmMessage', obj)
        })
        .catch((error) => {
          let paramModal = {}
          paramModal.message = error.response
            ? error.response.data.errors
              ? Object.values(error.response.data.errors).join('<br>')
              : error.response.data.message
            : 'Contate o administrador do sistema'
          paramModal.title = 'Ocorreu erro'
          paramModal.type = 'error'
          paramModal.callback = null
          paramModal.btConfirm = {
            name: 'Ok',
            show: true
          }
          paramModal.btCancel = {
            show: false
          }
          this.$store.commit('hideLoader')
          this.$store.commit('confirmMessage/showConfirmMessage', paramModal)
        })
    },

    openDialogForm (type, id) {
      if (type === 'upLoad') {
        this.idToEdit = id || 0
        this.uploadDialog = true
        return
      }
      this.formData = null
      this.frmContractsDialog = true
    },

    closeDialogForm (type) {
      if (type === 'upLoad') {
        this.uploadDialog = false
        return
      }
      this.frmContractsDialog = false
    },

    addOrRemovePermission (id) {
      // console.log(id);
    },

    getDocTypes (clear) {
      // console.log("delete");
      if (clear === 'clear') {
        this.formData.type = ''
        this.$refs.documentationForm.resetValidation()
      }
      this.$store.dispatch('documents/getDocTypes')
    },

    getDocSubTypesLocal (clear) {
      // if (!this.formData.type) {
      //   return;
      // }
      if (clear === 'clear') {
        this.formData.type = ''
        this.$refs.documentationForm.resetValidation()
      }

      // console.log('pqpqpqp',this.formData.type)
      this.$store.dispatch('documents/getDocSubTypes', this.formData.type)
    },

    getPermissions () {
      let obj = {
        url: '/api/permission',
        query: '',
        method: 'get',
        noLoader: true
      }
      this.$store.dispatch('request/doRequest', obj).then((response) => {
        this.permissionsList = response.data
      })
    },

    resetDialog () {
      this.$props.closeForm()
    },

    doSave () {
      // console.log(this.notify);
      // return;
      if (!this.$refs.documentationForm.validate()) {
        return
      }

      this.formData.notify_document = this.notify

      const callback = (data) => {
        this.formData = {
          ...data
        }
        this.formData.subType = this.formData.subType_id
      }

      this.formData.subType_id = this.formData.subType

      this.formData.validate_date = this.formData.indefinite_period ? '' : this.formData.validate_date

      this.formData.validate_date = this.formData.obtaining ? '' : this.formData.validate_date

      this.formData.alert_date = this.formData.validate_date ? this.formData.alert_date : '30'

      // If Obtaining == true, indefinite_period == false
      // If indefinite_period == true, obtaining == false

      if (this.formData.obtaining) {
        this.formData.indefinite_period = false
      }

      if (this.formData.indefinite_period) {
        this.formData.obtaining = false
      }

      if (!this.formData.validate_date) {
        let obj = {
          message:
            'Documentos sem data de vencimento não receberão as notificações do sistema, deseja continuar?',
          title: 'Aviso',
          callback: (_) => {
            console.log(this.formData)
            this.$props.saveDocumentation(this.formData, callback)
          },
          type: 'warning',
          btConfirm: { name: 'Sim', show: true },
          btCancel: { name: 'Não', show: true }
        }
        this.$store.commit('confirmMessage/showConfirmMessage', obj)
      } else {
        this.$props.saveDocumentation(this.formData, callback)
      }
    }
  }
}
</script>

<style>
</style>
